import { dbGet, dbSet } from './db';

const COMMON_KEY = 'common.runtime';
const BOOTSTRAP_KEY = 'play.bootstrap.current';
const FAMILY_SESSION_KEY = 'family.session.current';
const FAMILY_LOGIN_KEY = 'family.login.current';
const ACTIVITY_DATA_PREFIX = 'activity.data.';

// VM Ages 4-8 Placement must not rewrite the shared Activity cache used by
// Custom Levels. This is a session-only scope switch plus a separate DB key.
const VM_PLACEMENT_IDS = new Set([
  '5c63ffd2-0c77-4da4-86db-0a2966a4041f',
  '8e71a56a-0ea9-4760-b228-28ad57d4f4ad',
  'c53VNmpA5h',
]);
const VM_PLACEMENT_DATA_PREFIX = 'activity.placement.age_4_8.vm.';
let activeVmPlacement = false;

export const setActiveVmPlacementDataScope = (enabled) => { activeVmPlacement = enabled === true; };
export const isActiveVmPlacementActivity = (activityId) => (
  activeVmPlacement && VM_PLACEMENT_IDS.has(String(activityId || ''))
);
export const cacheVmPlacementActivityData = (activityId, data) => (
  isActiveVmPlacementActivity(activityId) && data?.languageVersionData?.immersion_vm
    ? dbSet(`${VM_PLACEMENT_DATA_PREFIX}${String(activityId)}`, { data, savedAt: Date.now() })
    : Promise.reject(new Error(`VM Placement data missing or scope inactive: ${activityId}`))
);
export async function getCachedVmPlacementActivityData(activityId) {
  if (!isActiveVmPlacementActivity(activityId)) return null;
  const record = await dbGet(`${VM_PLACEMENT_DATA_PREFIX}${String(activityId)}`);
  return record?.data?.languageVersionData?.immersion_vm ? record.data : null;
}


export const cacheCommonRuntime = (data) => dbSet(COMMON_KEY, { data, savedAt: Date.now() });
export async function getCachedCommonRuntime() {
  const value = await dbGet(COMMON_KEY);
  return value?.data || null;
}

export const cachePlayBootstrap = (data) => dbSet(BOOTSTRAP_KEY, { data, savedAt: Date.now() });
export async function getCachedPlayBootstrap() {
  const value = await dbGet(BOOTSTRAP_KEY);
  return value?.data || null;
}

export const cacheFamilySession = (data) => dbSet(FAMILY_SESSION_KEY, { data, savedAt: Date.now() });
export async function getCachedFamilySession() {
  const value = await dbGet(FAMILY_SESSION_KEY);
  return value?.data || null;
}

export const cacheFamilyLogin = (data) => dbSet(FAMILY_LOGIN_KEY, { data, savedAt: Date.now() });
export async function getCachedFamilyLogin() {
  const value = await dbGet(FAMILY_LOGIN_KEY);
  return value?.data || null;
}

export const cacheActivityData = (activityId, data) => (
  activityId && data
    ? dbSet(`${ACTIVITY_DATA_PREFIX}${String(activityId)}`, { data, savedAt: Date.now() })
    : Promise.resolve()
);
export async function getCachedActivityData(activityId) {
  if (!activityId) return null;
  const value = await dbGet(`${ACTIVITY_DATA_PREFIX}${String(activityId)}`);
  return value?.data || null;
}
